export default {
  getAll: {
    url: '/api/order/getAll',
    method: 'get'
  },
  create: {
    url: '/api/order/create',
    method: 'post'
  },
  update: {
    url: '/api/order/update',
    method: 'put'
  },
  delete: {
    url: '/api/order/delete',
    method: 'delete'
  },
  fileUpload: {
    url: '/api/order/cadUpload',
    method: 'post'
  },
  generateInvoice: {
    url: '/api/order/generateInvoice',
    method: 'post'
  },
  changeFileNameLocal: {
    url: 'https://upload.cylaser.cn/changeFileName',
    method: 'post'
  },
  changeFileNameAndCopyLocal: {
    url: 'https://upload.cylaser.cn/changeFileNameAndCopy',
    method: 'post'
  },
  changeFileName: {
    url: '/api/order/changeFileName',
    method: 'post'
  },
  complete: {
    url: '/api/order/complete',
    method: 'post'
  },
  getUncomplete: {
    url: '/api/order/getUncomplete',
    method: 'get'
  },
  getOrderData: {
    url: '/api/order/getOrderData',
    method: 'get'
  },
  getExcel: {
    url: '/api/order/getExcel',
    method: 'get'
  },
  customerReporter: {
    url: '/api/order/customerReporter',
    method: 'get'
  },
  deleteOrder: {
    url: '/api/order/deleteOrder',
    method: 'post'
  },
  sameOrder: {
    url: '/api/order/sameOrder',
    method: 'post'
  },
  downloadDebt: {
    url: '/api/order/downloadDebt',
    method: 'get'
  },
  getOrdersByCustomerAndTime: {
    url: '/api/order/getOrdersByCustomerAndTime',
    method: 'get'
  }
}



// WEBPACK FOOTER //
// ./src/api/order.js